<script setup lang="ts">
import { defineProps, withDefaults } from "vue";

withDefaults(
  defineProps<{
    spinnerColor?: "white" | "black" | "brown";
  }>(),
  {
    spinnerColor: "white",
  }
);

const colorClasses = {
  white: "text-white",
  black: "text-black",
  brown: "text-brown",
};
</script>

<template>
  <div
    class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] z-10 ml-auto"
    :class="colorClasses[spinnerColor]"
    role="status"
  ></div>
</template>

<style scoped></style>
